let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
import styled from 'styled-components';
import { colors, fontWeights, styledIf } from '@ovpn-ui/styles';
import { fontStack } from '../../../../styles';
export const EmptyValue = styled.div(_t || (_t = _`
    margin: 10px 0 0 0;

    text-align: center;
`));
export const OptionsList = styled.div(_t2 || (_t2 = _`
    width: 100%;

    height: auto;

    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 7px;
        height: 2px;

        background-color: ${0};

        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${0};
        border-radius: 10px;
    }
`), colors.white, colors.neutralLight);
export const Option = styled.div(_t3 || (_t3 = _`
    display: flex;

    align-items: center;

    justify-content: space-between;

    min-height: 36px;

    padding: 8px 16px;

    overflow-x: hidden;

    font-weight: ${0};

    border-radius: 4px;

    cursor: pointer;

    user-select: none;

    svg {
        margin-right: 8px;

        line-height: 36px;
    }

    span {
        display: flex;
        align-items: center;

        overflow: hidden;

        white-space: nowrap;

        text-overflow: ellipsis;
    }

    ${0}

    &[data-disabled="true"] {
        color: ${0};

        background-color: ${0};

        pointer-events: none;
    }

    &:hover {
        background-color: ${0};
    }

    &:not(:last-child) {
        margin-bottom: 4px;
    }
`), fontWeights.regular, styledIf('isSelected')(_t4 || (_t4 = _`
	    background-color: ${0};
    `), colors.neutralBgHover), colors.neutralTextPlaceholder, colors.neutralBg, colors.neutralBg);
export const GroupTitle = styled.div(_t5 || (_t5 = _`
    display: flex;
    gap: 8px;
    align-items: center;

    margin-bottom: 4px;
    padding: 8px 16px;

    font-weight: 500;
    font-size: ${0};
    line-height: ${0};
    letter-spacing: ${0};
`), fontStack.textSm.fontSize, fontStack.textSm.lineHeight, fontStack.textSm.letterSpacing);